<template>
<listp type="historical" />
</template>
<script>
import listp from '@/modules/CA_SP/components/actions/list.vue';
export default { components: { listp }};
</script>
